export function getLocalStorageInfo(storageName) {
  return JSON.parse(localStorage.getItem(storageName));
}
